import { useEffect } from 'react';

import { Debug } from '@hh.ru/browser-api-utils';
import { useSelector } from '@hh.ru/front-static-app';

import { uxfeedbackEvents } from 'src/modules/uxfeedback';

import useProfile from 'src/hooks/useProfile';

const Features = {
    uxFeedbackProfessionBasedSurvey: 'uxfeedback_profession_based_survey',
};

export const useUxFeedbackProfessionBasedSurvey = () => {
    const { isAuth, profile } = useProfile();
    const professionIdsString = useSelector(
        (state) => state.features[Features.uxFeedbackProfessionBasedSurvey] as string
    );

    useEffect(() => {
        if (isAuth) {
            try {
                const professionId = profile!.profession!.id;
                const professionIds = JSON.parse(professionIdsString) as string[];
                if (professionId && professionIds.includes(professionId)) {
                    uxfeedbackEvents.professionBasedSurvey();
                }
            } catch (e) {
                Debug.log('out error', e);
            }
        }
    }, [isAuth, professionIdsString, profile]);
};
